import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

const mapStateToProps = (state, props) => {
  return {
    isOwner: state.account.isContractOwner,
    closeMenu: props.closeMenu,
    resetTutorial: props.resetTutorial
  };
};

const connectedNavigation = ({isOwner, closeMenu, resetTutorial}) => (
  <Fragment>
    <div className="c-navigation__item">
      <Link to="/" onClick={closeMenu}>Home</Link>
    </div>
    <div className="c-navigation__item">
      <Link to="/coin" onClick={closeMenu}>Coin</Link>
    </div>
    <div className="c-navigation__item">
      <Link to="/coupons" onClick={closeMenu}>Redeem coupon</Link>
    </div>
    <div className="c-navigation__item">
      <Link to="/analytics" onClick={closeMenu}>Analytics</Link>
    </div>
    {isOwner ? (
      <div className="c-navigation__item">
        <Link to="/owner-dashboard" onClick={closeMenu}>Owner dashboard</Link>
      </div>
    ) : null}
    <div className="c-navigation__item">
      <Link to="/settings" onClick={closeMenu}>Settings</Link>
    </div>
    <div className="c-navigation__item">
      <Link to="/ether" onClick={closeMenu}>Get Ether</Link>
    </div>
    <div className="c-navigation__item">
      <a onClick={resetTutorial}>Show Tutorial</a>
    </div>
  </Fragment>
);

const NavigationMenu = connect(mapStateToProps)(connectedNavigation);

export default NavigationMenu;



// WEBPACK FOOTER //
// ./src/components/Components/NavigationMenu.js